const srlOptions = {
    thumbnails: {
        showThumbnails: false,
    },
}

export default srlOptions
